/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Correct_DoneInputs */

const en_us2_workout_correct_done = /** @type {(inputs: Workout_Correct_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set corrected`)
};

const pt_br2_workout_correct_done = /** @type {(inputs: Workout_Correct_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série corrigida`)
};

const es_419_workout_correct_done = /** @type {(inputs: Workout_Correct_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie corregida`)
};

const pt_pt2_workout_correct_done = /** @type {(inputs: Workout_Correct_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série corrigida`)
};

const fr_fr2_workout_correct_done = /** @type {(inputs: Workout_Correct_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Série corrigée`)
};

const de_de2_workout_correct_done = /** @type {(inputs: Workout_Correct_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satz korrigiert`)
};

const it_it2_workout_correct_done = /** @type {(inputs: Workout_Correct_DoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Serie corretta`)
};

/**
* | output |
* | --- |
* | "Set corrected" |
*
* @param {Workout_Correct_DoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_correct_done = /** @type {((inputs?: Workout_Correct_DoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Correct_DoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_correct_done(inputs)
	if (locale === "es-419") return es_419_workout_correct_done(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_correct_done(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_correct_done(inputs)
	if (locale === "de-DE") return de_de2_workout_correct_done(inputs)
	if (locale === "it-IT") return it_it2_workout_correct_done(inputs)
	return en_us2_workout_correct_done(inputs)
});
export { workout_correct_done as "workout.correct_done" }